import { absoluteCenter } from './../../utils/style-helpers/position.style.helper';
import styled from '@emotion/styled';
export const StyledNoMarketingConsent = styled.div(() => ({
    ...absoluteCenter,
}));
